import React from 'react';
import { ContentProductsCarousel } from '../../Products';
export var FundMostComparedFunds = function FundMostComparedFunds(_ref) {
  var funds = _ref.funds,
    title = _ref.title,
    subtitle = _ref.subtitle,
    subscriptions = _ref.subscriptions,
    _onFollow = _ref.onFollow,
    _ref$withSPA = _ref.withSPA,
    withSPA = _ref$withSPA === void 0 ? false : _ref$withSPA;
  return React.createElement(ContentProductsCarousel, {
    withSPA: withSPA,
    title: title,
    subtitle: subtitle,
    products: funds.items,
    subscriptions: subscriptions || [],
    onFollow: function onFollow(id, status) {
      return _onFollow ? _onFollow(id, status) : function () {};
    },
    fetching: funds.fetching,
    variant: "large",
    bottomMargin: true
  });
};